function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "Icons/Authors");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("rect", {
  id: "path-1",
  x: 0,
  y: 0,
  width: 16,
  height: 16
}));

var _ref5 =
/*#__PURE__*/
React.createElement("g", {
  id: "All-Screens",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Home---1820x1024",
  transform: "translate(-1549.000000, -98.000000)"
}, React.createElement("g", {
  id: "Popup-Copy",
  transform: "translate(1530.000000, 84.000000)"
}, React.createElement("g", {
  id: "Icons/Authors",
  transform: "translate(18.000000, 14.000000)"
}, React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, React.createElement("use", {
  xlinkHref: "#path-1"
})), React.createElement("g", {
  id: "Background"
}), React.createElement("path", {
  d: "M12.6993043,11.0074333 L10.2072174,9.89303333 C9.97217391,9.7878 9.82608696,9.5764 9.82608696,9.3412 L9.82608696,8.5523 C9.88582609,8.48696667 9.94869565,8.41253333 10.0136522,8.3304 C10.3368696,7.92206667 10.595913,7.46753333 10.7842609,6.9773 C11.1523478,6.82633333 11.3913043,6.50083333 11.3913043,6.13333333 L11.3913043,5.2 C11.3913043,4.9753 11.2973913,4.7576 11.1304348,4.5875 L11.1304348,3.3464 C11.1450435,3.21806667 11.2024348,2.45413333 10.5846957,1.8239 C10.0488696,1.2772 9.1793913,1 8,1 C6.8206087,1 5.95113043,1.2772 5.41530435,1.82366667 C4.79756522,2.4539 4.85495652,3.21806667 4.86956522,3.3464 L4.86956522,4.5875 C4.7026087,4.7576 4.60869565,4.9753 4.60869565,5.2 L4.60869565,6.13333333 C4.60869565,6.4173 4.75295652,6.68213333 4.99921739,6.85876667 C5.23817391,7.70506667 5.73826087,8.34276667 5.91304348,8.5474 L5.91304348,9.3195 C5.91304348,9.54536667 5.77530435,9.75256667 5.55382609,9.86083333 L3.2266087,10.9962333 C2.46982609,11.3656 2,12.0735333 2,12.8444667 L2,13.6 C2,14.7074 5.92478261,15 8,15 C10.0752174,15 14,14.7074 14,13.6 L14,12.8899667 C14,12.0877667 13.5014783,11.3663 12.6993043,11.0074333 Z",
  id: "Path",
  stroke: "#1E1F20",
  strokeWidth: 1.44,
  fill: "#FFFFFF",
  fillRule: "evenodd",
  mask: "url(#mask-2)"
})))));

var SvgPerson = function SvgPerson(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "14px",
    height: "16px",
    viewBox: "0 0 14 16",
    ref: svgRef
  }, props), title === undefined ? _ref2 : React.createElement("title", null, title), _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgPerson, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/person.14aadbc6.svg";
export { ForwardRef as ReactComponent };